import React, { useState, useContext, useEffect } from 'react';
import { useFormikContext } from 'formik';

import { ResponsiveContext } from '../../App';
import { Simulation } from '../../types/main';
import { creeClassNamesZoneSaisie } from '../../utils/utils';
import { SaisieContext } from '../formConteneur';
import { MySelect } from '../champsSaisieAffichage/mySelect';
import { MyListeBoutons } from '../champsSaisieAffichage/myListeBoutons';
import { MyTextInput } from '../champsSaisieAffichage/myTextInput';
import { listeSpesL } from '../../donneesFilieres/filiereL';
// import { VoirDetail } from '../boutons/generaux/voirDetail';

export const SaisieSpe: React.FC = () => {
  // const { etapeSaisie, etapesSaisie } = useContext(EtapesSaisieContext);
  const { values, setFieldValue } = useFormikContext();
  const { modeAffichage, setBoutonSuivant } = useContext(SaisieContext);
  const simulation = values as Simulation;
  const { filiere, sous_filiere } = simulation;
  const { dimensions } = useContext(ResponsiveContext);
  const classNamesZoneSaisie = creeClassNamesZoneSaisie(dimensions.largeur, 4);
  const [tableauBoutons, setTableauBoutons] = useState<string[]>([]);

  useEffect(() => {
    setBoutonSuivant('non');
  }, [])

  useEffect(() => {
    switch (filiere) {
      case 'ES':
        setTableauBoutons([
          'Economie approfondie',
          'Mathématiques',
          'Sciences sociales et politiques',
        ]);
        break;
      case 'S':
        switch (sous_filiere) {
          case 'S-SVT':
            setTableauBoutons([
              'Mathématiques',
              'Physique - Chimie',
              'SVT',
              'ISN',
              // 'Écologie, agronomie et territoires',
            ]);
            break;
          case 'S-Écologie, agronomie et territoires':
            setTableauBoutons([
              'Mathématiques',
              'Physique - Chimie',
              // 'SVT',
              'ISN',
              'Écologie, agronomie et territoires',
            ]);
            break;
          case 'S-Sciences de l’ingénieur':
          default:
            setTableauBoutons([
              'Aucune',
              'Mathématiques',
              'Physique - Chimie',
              // 'SVT',
              'ISN',
              // 'Écologie, agronomie et territoires',
            ]);
            break;
          }
        break;
      case 'L':
        setTableauBoutons(listeSpesL);
        break;
      default:
        break;
    }
  }, [filiere, sous_filiere])


  return (
    <div
      className={classNamesZoneSaisie.join(' ')}
      // style={styleZoneSaisie}
    >
      <div className="col1">
        <div className="col">
          <h1 className="titre">Spécialité</h1>
          <div className="group" style={{ display: "flex" }}>
            <MyListeBoutons
              label="specialite"
              // labelAvecRC={<><u>F</u>ilière</>}
              // toucheRC={['f', 'F']}
              name="specialite"
              required
              autoFocus={true}
              boutons={tableauBoutons}
              // boutons={['S', 'ES', 'L', 'STMG']}
              classes={['boutonSize2']}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
